import React from "react";
import Navbar from "./Navbar";

export default function AboutUs() {

  
  return (
    <div className="make-test">
      <Navbar />   
      <div className="container">
        <div className="row p-5 text-center">
          <div className="col">
            <img
              src={"dragonfly.png"}
              className="card-img-top w-25"
              alt="..."
            ></img>
            <h2 className="text-light mt-3">About Us</h2>
          </div>
        </div>
        
        <div className="row text-center">
        <div className="col">
          <p className="text-light">
            Thank you for purchasing this Color Test program.
          </p>
          <p className="text-light">
            It has been created with much love and care to help facilitate your
            Chromotherapy work. We hope you enjoy it as much as we have done
            creating it for you.
          </p>
          <p className="text-light">
            If you have any question, please let us know by contact form.
          </p>
          <p className="text-light">
            Thank you in advance and blessing from all of us!
          </p>
        </div>
        </div>
      </div>
    </div>
  );
}
